import fetch from 'utils/request';
import { deepCopy, formatDate } from 'utils/index';

// ! 获取子品牌以及供应商列表
export function apiPostSmsConfigData(data){
    return fetch.post('/ocs-sms/getSmsConfig', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 获取短信设置列表
export function apiPostSmsSettingsList(data){
    return fetch.post('/ocs-sms/selectSmsConfig', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 新增/修改短信设置
export function apiPostSmsSettingsTouchIn(data) {
	data = deepCopy(data);
	if(data.brand) data.brand = data.brand.toString();
	return fetch.post(`/ocs-sms/saveSmsConfig`, data, {apiType: 'workflow'}).then(res => res);
} 

// ! 删除短信设置
export function apiPostSmsSettingsDelete(data) {
	return fetch.post(`/ocs-sms/deleteSmsConfig`, data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
} 

// ! 更改短信设置状态
export function apiPostSmsSettingsStatus(data) {
	return fetch.post(`/ocs-sms/onoffSmsConfig`, data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
} 

// ! 获取短信模板列表
export function apiPostSmsTemplateList(data){
    return fetch.post('/ocs-sms/selectSmsTemplet', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 新增/修改短信设置
export function apiPostSmsTemplateTouchIn(data) {
	data = deepCopy(data);
	if(data.subbrandId) data.subbrandId = data.subbrandId.toString();
	return fetch.post(`/ocs-sms/saveSmsTemplet`, data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
} 

// ! 删除短信设置
export function apiPostSmsTemplateDelete(data) {
	return fetch.post(`/ocs-sms/deleteSmsTemplet`, data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
} 

// ! 获取客户查询导入列表
export function apiPostSmsImportLogList(data){
	data = deepCopy(data);
	if(data.date) {
		data.createStartTime = formatDate(data.date[0], 'YYYY-MM-DD HH:mm:ss');
		data.createEndTime = formatDate(data.date[1], 'YYYY-MM-DD HH:mm:ss');
	}
	delete data.date;
    return fetch.post('/ocs-sms/selectSmsImport', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 获取短信单发列表
export function apiPostSmsSendSingleList(data){
	data = deepCopy(data);
	if(data.date1) {
		data.createStartTime = formatDate(data.date1[0], 'YYYY-MM-DD HH:mm:ss');
		data.createEndTime = formatDate(data.date1[1], 'YYYY-MM-DD HH:mm:ss');
	}

	if(data.date2) {
		data.sendStartTime = formatDate(data.date2[0], 'YYYY-MM-DD HH:mm:ss');
		data.sendEndTime = formatDate(data.date2[1], 'YYYY-MM-DD HH:mm:ss');
	}

	if(data.date3) {
		data.scheduleStartTime = formatDate(data.date3[0], 'YYYY-MM-DD HH:mm:ss');
		data.scheduleEndTime = formatDate(data.date3[1], 'YYYY-MM-DD HH:mm:ss');
	}
	delete data.date1;
	delete data.date2;
	delete data.date3;
    return fetch.post('/ocs-sms/selectSmsSingle', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 获取短信群发列表
export function apiPostSmsSendGroupList(data){
	data = deepCopy(data);
	if(data.date1) {
		data.createStartTime = formatDate(data.date1[0], 'YYYY-MM-DD HH:mm:ss');
		data.createEndTime = formatDate(data.date1[1], 'YYYY-MM-DD HH:mm:ss');
	}

	if(data.date2) {
		data.sendStartTime = formatDate(data.date2[0], 'YYYY-MM-DD HH:mm:ss');
		data.sendEndTime = formatDate(data.date2[1], 'YYYY-MM-DD HH:mm:ss');
	}

	if(data.date3) {
		data.scheduleStartTime = formatDate(data.date3[0], 'YYYY-MM-DD HH:mm:ss');
		data.scheduleEndTime = formatDate(data.date3[1], 'YYYY-MM-DD HH:mm:ss');
	}
	delete data.date1;
	delete data.date2;
	delete data.date3;
    return fetch.post('/ocs-sms/selectSmsGroup', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 获取批次详情列表
export function apiPostSmsSendGroupDetailsList(data){
    return fetch.post('/ocs-sms/selectSmsGroupDetails', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 获取短信模板列表 - 下拉
export function apiPostSmsCascadeTemplateList(data){
    return fetch.post('/ocs-sms/cascadeTemplet', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 获取短信账号列表 - 下拉
export function apiPostSmsConfigList(){
    return fetch.post('/ocs-sms/getConfigList').then(res => res);
}

// ! 新增 / 修改 短信单发
export function apiPostSmsSaveSmsSingle(data){
	data = deepCopy(data);
	if(data.scheduleTime) {
		data.scheduleTime = formatDate(data.scheduleTime, 'YYYY-MM-DD HH:mm:ss');
	} else {
		data.scheduleTime = '';
	}
    return fetch.post('/ocs-sms/saveSmsSingle', data).then(res => res);
}

// ! 新增 / 修改 短信群发
export function apiPostSmsSaveSmsGroup(data){
	data = deepCopy(data);
	console.log(data)
	if(data.scheduleTime) {
		data.scheduleTime = formatDate(data.scheduleTime, 'YYYY-MM-DD HH:mm:ss');
	} else {
		data.scheduleTime = '';
	}
    return fetch.post('/ocs-sms/saveSmsGroup', data).then(res => res);
}

// ! 导入客户信息
export function apiPostSmsImportCustomer(data){
    return fetch.post('/ocs-sms/importCustomer', data).then(res => res);
}

// ! 导入客户信息
export function apiPostSmsSelectSmsGroupDetails(data){
    return fetch.post('/ocs-sms/selectSmsGroupDetails', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 获取模板内容
export function apiPostSmsGetTemplateBody(data){
    return fetch.post('/ocs-sms/getTempletBody', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 取消短信单发
export function apiPostSmsCancelSingle(data){
    return fetch.post('/ocs-sms/cancelSmsSingle', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 取消短信群发
export function apiPostSmsDeleteSmsGroup(data){
    return fetch.post('/ocs-sms/cancelSmsGroup', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 根据沟通ID获取短信内容
export function apiPostSmsSelByIncident(data){
    return fetch.post('/ocs-sms/selSmsByIncident', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}

// ! 获取导入客户明细
export function apiPostSmsSelectSmsImportDetail(data){
    return fetch.post('/ocs-sms/selectSmsImportDetail', data, {apiType: 'workflow', contentType: 'formData'}).then(res => res);
}